export default {
	functional: true,
	name: 'Message',
	props: {
		text: {
			type: String,
			require: true,
		},
	},
	render(h, context) {
		return h(
			'span',
			{
				class: 'global-message',
			},
			context.props.text
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/Message.js